import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

const Compare = () => dynamicImport(import('./pages/Compare.vue'))

export default ({ config, country }) => {
  // [ACQ-699] The `product-comparison` module will soon be replaced
  // with the new `models-comparison` module.
  const isNewModelsComparisonActiveInCountry =
    config.FF_NEW_MODELS_COMPARISON_ACTIVE_IN_COUNTRY?.includes(country)

  return isNewModelsComparisonActiveInCountry
    ? []
    : [
        {
          name: ROUTES.MODELS_COMPARISON.HOME,
          path: 'compare',
          component: Compare,
        },
        {
          name: ROUTES.MODELS_COMPARISON.CATEGORY,
          path: 'compare/:category(smartphones|tablets)',
          component: Compare,
        },
        {
          name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
          path: 'compare/:productA/:productB',
          component: Compare,
        },
      ]
}
